export const GET_MAINTENANCE_EVENTS = 'roasters/GET_MAINTENANCE_EVENTS';
export const GET_MAINTENANCE_EVENTS_SUCCESS = 'roasters/GET_MAINTENANCE_EVENTS_SUCCESS';
export const GET_MAINTENANCE_EVENTS_FAILED = 'roasters/GET_MAINTENANCE_EVENTS_FAILED';
export const ADD_MAINTENANCE_EVENTS = 'roasters/ADD_MAINTENANCE_EVENTS';
export const UPDATE_MAINTENANCE_EVENT = 'roasters/UPDATE_MAINTENANCE_EVENT';